import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

import deTranslation from "./locales/de.json";
import itTranslation from "./locales/it.json";
import frTranslation from "./locales/fr.json";

const supportedLanguages = ["de", "it", "fr"];

const getLanguage = () => {
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lang");

  if (urlLang && supportedLanguages.includes(urlLang)) {
    return urlLang; // Langue définie par l'URL
  }

  // Get the language from cookies
  const cookieLang = document.cookie.split("; ").find(row => row.startsWith("lang="));
  const lang = cookieLang ? cookieLang.split("=")[1] : null;
  if (lang && supportedLanguages.includes(lang)) {
    return lang; // Langue définie par le cookie
  }

  const browserLangs = navigator.languages.map(lang => lang.split("-")[0]);
  const detectedLang = browserLangs.find(lang => supportedLanguages.includes(lang));

  return detectedLang || "fr"; // Langue détectée ou fallback sur FR
};

const resources = {
  de: { translation: deTranslation },
  it: { translation: itTranslation },
  fr: { translation: frTranslation }
};

const lng = getLanguage();
console.log(`Detected language: ${lng}`);

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: lng,
    interpolation: {
      escapeValue: false,
    }
  });

export { i18n, supportedLanguages };
